module.exports = __webpack_public_path__ + "static/media/bar_echocardiogram_HL.87005043.png";